import { DisruptionsAreaRoutes } from '@backoffice-frontend/common'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { ErrorOctagonIcon } from '@moia-dev/pace-icons'

export const DisruptionsAreaNavigationIcon = ErrorOctagonIcon

export const DisruptionsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={DisruptionsAreaRoutes.route}
      Icon={ErrorOctagonIcon}
    />
  )
}
